import React from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import { Constants } from '@pwc/pwc-deals-web-common';
import ShowForRole from '../../../features/security/ShowForRole';
import UserViewStatusPill from './UserViewStatusPill';
import VersionStatus from './VersionStatus';
import { DraftPillClientView } from './DraftPill';
import ApprovalPill from './ApprovalPill';
import './PillContainer.scss';

import { getIsThirdPartyMember } from '../../redux/security/loggedInUser/loggedInUserSlice';

const PillContainer = ({
  className,
  content,
  projectId,
  allowDraftPill,
  hideVersionStatus = false,
  hideTextVersion = false,
}) => {
  const isThirdPartyMember = useSelector(getIsThirdPartyMember);

  return (
    !isThirdPartyMember && (
      <div
        className={classnames('pill-container', className)}
        data-testid="pill-container"
      >
        <UserViewStatusPill userViewStatus={content.userViewStatus} />

        {!hideVersionStatus && (
          <ShowForRole
            projectId={projectId}
            roles={Constants.USER_ROLE_GROUPS.INTERNAL}
          >
            <VersionStatus
              content={content}
              allowDraftPill={allowDraftPill}
              hideTextVersion={hideTextVersion}
            />
          </ShowForRole>
        )}

        <ShowForRole
          projectId={projectId}
          roles={Constants.USER_ROLE_GROUPS.CLIENT}
        >
          <DraftPillClientView />
        </ShowForRole>
        <ApprovalPill versionStatus={content.versionStatus} />
      </div>
    )
  );
};

export default PillContainer;
